<template>
    <el-dialog title="快速发货" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false" width="30%">
        <el-form size="small" ref="order" :model="order" label-width="100px">
          <el-form-item label="物流公司" prop="express_id" :rules="[{required: true,message: '请选择物流公司'}]">
            <el-select v-model="order.express_id" placeholder="请选择快递公司">
              <el-option :label="item.express_name" v-for="(item, index) in expressList" :key="index" :value="item.express_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物流单号" prop="express_no" :rules="[{required: true,message: '请填写物流单号'}]">
            <el-input v-model="order.express_no" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item label="发货类型" prop="shipment_type" :rules="[{required: true,message: '请选择发货类型'}]">
            <div>
              <el-radio :disabled="order.shipment_type_status==='2'?true:false" v-model="order.shipment_type" @change="getCommoditys(1)" label="1">按订单发货</el-radio>
              <el-radio :disabled="order.shipment_type_status==='2'?true:false" v-model="order.shipment_type" @change="getCommoditys(2)" label="2">商品分包裹发货</el-radio>
            </div>
            <p class="gray9">选择商品类型</p>
          </el-form-item>
          <el-form-item label="发货商品" prop="shipment_commodity_label" :rules="shipment_commodity_rules" v-if="order.shipment_type==2">
            <el-checkbox-group v-model="order.shipment_commodity_label">
              <div v-for="(item, index) in shipment_commodity">
                <el-checkbox  :disabled="item.shipment_status===1 || item.refund && (item.refund.status.value == 0 || item.refund.status.value == 20) ? true : false" :label="item.order_product_id" name="shipment_commodity_label">
                名称：{{item.product_name}} 规格：{{item.product_attr}} 数量：{{item.total_num}}
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="submitFunc()" :loading="loading">发货</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import OrderApi from '@/api/order.js';
    export default {
        data() {
            return {
                order_id: 0,
                loading: false,
                /*左边长度*/
                formLabelWidth: '100px',
                /*是否显示*/
                dialogVisible: true,
                /*表单*/
                order: {
                    express_id: null,
                    express_no: '',
                    shipment_type: '1',
                    shipment_type_status: '1',
                    shipment_commodity_label:[],
                },
                shipment_commodity:[],
                shipment_commodity_rules:[],
                expressList:[],
            };
        },
        props: ['dataModel'],
        created() {
            this.getParams();

        },
        methods: {
          /*获取参数*/
          getParams() {
            let self = this;
            OrderApi.expressList({}, true)
              .then(data => {
                self.loading = false;
                self.expressList = data.data.expressList;
              })
              .catch(error => {
                self.loading = false;
              });
            OrderApi.getShipmentType({
              order_id: this.dataModel.order_id
            }, true)
              .then(data => {
                self.order.shipment_type = data.data.shipment_type + '';
                self.order.shipment_type_status = data.data.shipment_type + '';
                if (self.order.shipment_type_status === '2') {
                  self.getCommoditys(2);
                }
              });
          },
            /*确认事件*/
            submitFunc(e) {
                let self = this;
                let param = this.order;
                self.$refs.order.validate((valid) =>
                {
                    if (valid) {
                        self.loading = true;
                        OrderApi.delivery({
                              param: param,
                              order_id: this.dataModel.order_id
                            },
                            true
                          ).then(data =>
                        {
                            self.loading = false;
                            self.$message({
                                message: '恭喜你，发货成功',
                                type: 'success'
                            });
                            self.dialogFormVisible();
                        }).catch(error =>
                        {
                            self.loading = false;
                        });
                    }
                });
            },
            getCommoditys(e){
              let self = this;
              if (e === 1) {
                self.loading = false;
                self.shipment_commodity_rules = [];
                return;
              }
              self.shipment_commodity_rules = [{type: 'array',required: true,message: '请选择发货商品', trigger: 'change'}];
              OrderApi.getCommodity({
                order_id: this.dataModel.order_id
              }, true)
                .then(data => {
                  self.loading = false;
                  self.shipment_commodity = data.data.list;
                })
                .catch(error => {
                  self.loading = false;
                });
            },


            /*关闭弹窗*/
            dialogFormVisible() {
                this.$emit('closeDialog', {openDialog: false});
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/Express.vue